import type { RouteObject } from 'react-router-dom';
import AdminStudentsList from '@pages/AdminStudentsPage/AdminStudentsList';
import AdminStudentDetails from '@pages/AdminStudentsPage/AdminStudentDetails';

const adminStudentsRoutes: RouteObject[] = [
    {
        path: '/admin/students',
        element: <AdminStudentsList />,
    },
    {
        path: '/admin/students/:id',
        element: <AdminStudentDetails />,
    },
];

export default adminStudentsRoutes;
